export { HighlightSearchTermContainer as HighlightSearchTerm } from './HighlightSearchTerm.container';
